import Grid from "@mui/material/Grid/Grid";
import {CustomLabelMediumBold, CustomLabelMediumRegular, CustomLabelSmallMedium} from "../common/CustomLabel";
// import IPHONE15 from "../../assets/images/iPhone 15 Pro.png";
import Paper from "@mui/material/Paper/Paper";
import ARROW_UP from "../../assets/images/arrow-up-right.png";
import React from "react";
import Box from "@mui/material/Box/Box";
import {useNavigate} from "react-router-dom"

const AboutUs=()=>{
    const navigate = useNavigate();
    
    const onClickLearnMore = () => {
        navigate('/about-us');
    };

    return(
        <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}, px :{ xs: 1, md: 5}}} justifyContent={"center"}>
            <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                <CustomLabelMediumBold text={"ABOUT US"} fontWeight={700} color={"#5E17EB"}/>
            </Grid>


            <Grid item container justifyContent={"space-between"}
                  sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "10px", md: "40px"}}}>

                <Grid item xs={12} sx={{display: {xs: 'flex', lg: 'none'}}}>
                    {/* <img src={IPHONE15} alt={"OSTRYX"} style={{width: "100%", height: "100%"}}/> */}
                    <img src="/images/ostryx-lap.png" alt={"OSTRYX"} style={{width: "100%", height: "100%"}}/>
                </Grid>


                <Grid item xs={12} lg={5.8} sx={{marginTop: {xs: "20px", lg: "0px"}}}>
                    <Paper style={{width: "100%", background: "#FAF7FF", borderRadius: 25}}>
                        <Grid item container
                              sx={{padding: {xs:"10px",md:"20px 40px"}}}>

                            <Grid item container style={{marginTop: "10px"}}>
                                <CustomLabelMediumRegular
                                    normal={true}
                                >
                                        <span>
                                            <p>
                                            Hiring skilled developers has become a frustrating and unreliable process. Businesses face long hiring cycles, inconsistent talent, and the constant risk of scams on freelancing platforms. Too much time is wasted reviewing profiles, negotiating terms, and dealing with missed deadlines—with no guarantee of quality work.
                                            </p>
                                            <p>
                                            <b>OSTRYX</b> was founded in <b>2018</b> to solve this problem. <b>Our mission </b> is to connect businesses with <b>trusted, highly skilled developers</b> who deliver <b>real, high-quality digital solutions.</b>
                                            </p>
                                            <p>
                                            With a strong focus on the American market, we offer on-demand developers, full project development, and equity-based partnerships. In <b>2024</b>, Ethan Karian—once a client who faced scams himself - joined as a partner to help expand <b>OSTRYX</b> into North America.
                                            </p>
                                            <p>
                                            Unlike freelancing platforms with complex hiring processes and unreliable talent, <b>OSTRYX</b> makes digital development easy, professional, and trustworthy.
                                            </p>
                                        </span>
                                </CustomLabelMediumRegular>
                            </Grid>

                            <Grid item onClick={onClickLearnMore}>

                                <Grid item container sx={{
                                    border: "1.5px solid #F5F5F5",
                                    borderRadius: "16px",
                                    padding: {xs:"10px 15px",md:"15px 25px"},
                                    background: "#5E17EB", marginTop: "20px",
                                    cursor: "pointer"
                                }}
                                      alignItems={"center"} justifyContent={"center"}>

                                    <Grid item>
                                        <CustomLabelSmallMedium text={"Learn More"} color={"white"}/>
                                    </Grid>

                                    <Grid item style={{marginLeft: "10px"}}>
                                        <Box component={"img"}  src={ARROW_UP} alt={"Arrow Up"} sx={{width:{xs:"18px",md:"24px"}}}/>
                                    </Grid>

                                </Grid>

                            </Grid>

                        </Grid>
                    </Paper>
                </Grid>


                <Grid item xs={5.8}
                      sx={{
                        //   maxHeight: "100%",
                        //   width: "100%",
                          padding: "0px",
                        //   position: "relative",
                          display: {xs: 'none', lg: 'flex'}
                      }}>
                    <Grid container justifyContent={"flex-end"}>
                        {/* <img src={IPHONE15} alt={"OSTRYX"} style={{ */}
                        <img src="/images/ostryx-lap.png" alt={"OSTRYX"} style={{
                            // position: "absolute",
                            top: 0,
                            height: "100%",
                            maxWidth: "100%",
                            objectFit: "cover",
                            borderRadius: "25px",
                            // width: {lg: "100%", xlg: "auto"}
                        }}/>

                    </Grid>
                </Grid>


            </Grid>


        </Grid>
    )
}


export default AboutUs;
